module.exports = __webpack_public_path__ + "static/img/14000515.62fb79b3.png";